var generateStyle = function generateStyle(componentTheme) {
  return {
    quizEntryBank: {
      backgroundColor: componentTheme.quizEntryBankBackgroundColor,
      border: "".concat(componentTheme.quizEntryBankBorderSize, " dashed ").concat(componentTheme.quizEntryBankBorderColor),
      cursor: 'pointer',
      padding: componentTheme.quizEntryBankPadding,
      marginTop: componentTheme.quizEntryBankTopMargin
    },
    quizEntryBankText: {
      textAlign: 'left'
    },
    alertWrapper: {
      marginBottom: componentTheme.alertWrapperMargin
    }
  };
};
export default generateStyle;